<div
  class="d-flex flex-column"
  style="gap: .75rem">

  <div class="selected-exercises-list">
    @for (exc of selectedExerciseList(); track exc.id) {
      <div class="selected-exercise-entry">
        <div>{{ exc.title }}</div>

        <div class="delete-icon">
          <i
            class="pi pi-trash"
            (click)="removeExerciseFromPlan(exc)"></i>
        </div>
      </div>
    }
  </div>

  @if (selectedExerciseList() && selectedExerciseList()!.length > 0) {
    <p-button
      severity="primary"
      label="Zum Therapieplan"
      icon="pi pi-file"
      [fluid]="true"
      (onClick)="routeToTherapyPlanDetails()" />
  }
</div>
